import { BREAKPOINTS, TextButton as Button, COLORS, ComponentL, ComponentTextStyle, Size, SystemIcons, TypographyBase } from "@laerdal/life-react-components";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ProductArticleDto } from "../../../model/dto/productArticleDto";

const Components = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

const TopIssues = styled.div`
    ${BREAKPOINTS.LARGE}{
        display: grid;
        gap: 50px 88px;
    }
    margin-top: 16px;
    width: 100%;
    display: flex;
    gap: 32px;
    flex-direction: column;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, auto);
`;

const ArticleDetails = styled.div`
    display: flex;
    gap: 8px;
    flex-direction: column;
    word-wrap: break-word;
    word-break: break-word;
    overflow-wrap: break-word;
    
    ${BREAKPOINTS.LARGE}{
        border: 0px;
    }

    border-bottom: 1px solid ${COLORS.neutral_100};
`;

const ReadMoreButton = styled(Button)`
    align-self: start;
    span {
        display: flex;
        align-items: center;
    }
`;

interface MostCommonInquiriesProps {
    topIssues: ProductArticleDto[];
}

const MostCommonInquiries = ({ topIssues }: MostCommonInquiriesProps) => {
    const { t } = useTranslation("landingPage");
    const navigate = useNavigate();

    if (topIssues.length === 0) {
        return null;
    }

    return (
        <Components>
            <TypographyBase id='most-common-inquiries' $fontSize={32} $lineHeight={32} $fontWeight={700}>{t('Most common inquiries')}</TypographyBase>
            
            <TopIssues>
                {topIssues.map((article, index) =>
                    <ArticleDetails key={`article-${index}`}>
                        <ComponentL textStyle={ComponentTextStyle.Bold}>
                            <div style={{ fontFamily: "'Lato', sans-serif" }} dangerouslySetInnerHTML={{ __html: article.name }}></div>
                        </ComponentL>
                        <ComponentL textStyle={ComponentTextStyle.Regular}>
                            <div style={{ fontFamily: "'Lato', sans-serif" }} dangerouslySetInnerHTML={{ __html: article.text }}></div>
                        </ComponentL>

                        <ReadMoreButton
                            variant="tertiary"
                            size={Size.Small}
                            onClick={() => {
                                if (!!article.link)
                                    navigate(`/articles/Knowledge/${article.link}`);
                                else
                                    navigate(`/articles/${article.articleNumber}`);
                            }}>
                            {t('Read more')} <SystemIcons.ArrowLineRight />
                        </ReadMoreButton>
                    </ArticleDetails>
                )}
            </TopIssues>
        </Components>
    );
};

export default MostCommonInquiries;
